import {
  createReducer,
  createRequestReducer
} from 'utils';

import {
  CLEAR_PROGRAMS,
  GET_PROGRAMS
} from './constants';

const initialState = {
  results: [],
  isFetching: false,
  fetchingErrors: null
};

export default createReducer(initialState, {
  [GET_PROGRAMS]: (state, action) => {
    return createRequestReducer(state, action, {
      SEND: (state, action) =>
        Object.assign(state, {
          isFetching: true,
          fetchingErrors: null
        }),

      SUCCESS: (state, action) => {
        return Object.assign(state, {
          results: action.request.response.results,
          isFetching: false
        });
      },

      FAIL: (state, action) =>
        Object.assign(state, {
          isFetching: false,
          fetchingErrors: action.request.error
        })
    });
  },

  [CLEAR_PROGRAMS]: () => {
    return initialState;
  }
});



// WEBPACK FOOTER //
// ./src/redux/Programs/reducer.js